import React from 'react';
import PropTypes from 'prop-types';

import IconSpothero from '@spothero/icons/spothero';
import {Box, Icon, Image, Link, Text, useTheme} from '@spothero/ui';

import {
    widgetFooterStyleProps,
    widgetFooterTextStyleProps,
    widgetFooterLogoStyleProps,
    widgetFooterSecurityStyleProps,
} from './WidgetFooterStyleProps';

const WidgetFooter = ({trackingLink, destinationId}) => {
    const {
        partnerWidgetStyles: {footerAreaStyles: customFooterAreaStyles},
    } = useTheme();

    return (
        <Box
            {...widgetFooterStyleProps}
            {...customFooterAreaStyles.footerContainer}
        >
            <Link
                target="_parent"
                href={`${trackingLink}&kind=destination&id=${destinationId}`}
                aria-label="Link To SpotHero"
            >
                <Icon as={IconSpothero} {...widgetFooterLogoStyleProps} />
            </Link>
            <Text {...widgetFooterTextStyleProps}>
                Parking powered <br />
                by{' '}
                <Link
                    target="_parent"
                    href={`${trackingLink}&kind=destination&id=${destinationId}`}
                    fontWeight="normal"
                    aria-label="Link To SpotHero"
                >
                    SpotHero
                </Link>
            </Text>
            <Box {...widgetFooterSecurityStyleProps}>
                <Image
                    width="73px"
                    height="40px"
                    alt="Norton DigiCert Seal"
                    src="https://res.cloudinary.com/spothero/image/upload/$w_73,$h_40,$q_50/c_fill,f_auto,fl_progressive,dpr_2,h_$h,q_$q,w_$w/logos/digicert-secured-seal"
                />
            </Box>
        </Box>
    );
};

WidgetFooter.propTypes = {
    trackingLink: PropTypes.string.isRequired,
    destinationId: PropTypes.number.isRequired,
};

export default WidgetFooter;
